<template>
    <div class="blackout" :class="{blocked: blocked, show: show}">
        <div class="content vertical-align">
            <h1>Well, that wasn't meant to happen!</h1>
            <hr/>
            <p>Sorry, but it looks like we've run into a problem.</p>
            <p>{{errorMessage}}</p>

        </div>
    </div>
</template>

<script>
    
    export default {
        name: 'FatalErrorOverlay',
        components: {},
        props: [
            'display'
        ],
        data: function() {
            return {
                show: false,
                blocked: false,
                timeout: null
            };
        },
        computed: {
            errorMessage() {
                return this.$store.state.activity.error.fatal;
            }
        },
        watch: {
            errorMessage() {
                this.toggleDisplay();
            },
            show() {
                if (this.show === true){
                    document.body.classList.add('no-scroll'); 
                } else {
                    document.body.classList.remove('no-scroll'); 
                }
            }
        },
        created() {
            this.toggleDisplay();  
        },
        methods: {
            toggleDisplay() {
                
                if(this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }
                if(this.errorMessage) {
                    this.show = false;
                    this.blocked = true;
                    this.timeout = setTimeout(() => {
                        this.show = true;
                    }, 10);
                } else {           
                    this.blocked = true;
                    this.show = false;
                    this.timeout = setTimeout(() => {
                        this.blocked = false;
                    }, 500);
                }
                
            }, 
            
        }
    };
</script>

<style scoped>
    
    .blackout {background-color: rgba(0,0,0,.9); position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 999; opacity: 0; transition: .5s; display: none;}
    .blackout.show {transition-delay: .15s; opacity: 1;}
    .blackout.blocked {display: block;}
        .blackout .content {color: #fff; text-align: center; width: 90vw; max-width: 35rem; position: absolute; right: 0; left: 0; margin: auto; overflow-wrap: break-word;}

</style>